<!--
    File: Lesson.vue
-->

<template>
    <v-container fluid>
        <v-row>
            <v-col sm="12" md="6" :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
                <v-card outlined>
                    <v-toolbar class="elevation-0" color="background">
                        <v-toolbar-title>수업 관리</v-toolbar-title>
                    </v-toolbar>
                    <v-list class="pa-3">
                        <v-subheader>LESSONS : {{lessons.length}}</v-subheader>
                        <v-list-item v-for="lesson in lessons.slice(offset, offset + 10)" :key="lesson.id" @click="select(lesson)">
                            <v-list-item-icon>
                                <v-icon>{{lesson.studio == 0 ? 'mdi-earth' : 'mdi-map-marker'}}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title class="ml--20" v-text="lesson.name" />
                            <v-list-item-subtitle class="pl-3" v-text="lesson.content" />
                        </v-list-item>
                    </v-list>
                    <v-row v-if="pages == 1" class="pa-3" />
                    <v-row v-if="pages > 1" class="pa-3">
                        <v-divider />
                    </v-row>
                    <v-row v-if="pages > 1" class="ma-3" justify="center">
                        <v-pagination circle v-model="page" :length="pages" @input="move()"/>
                    </v-row>
                </v-card>
                <v-row v-if="lessons.length > 0 && edit == null" class="pa-3" align="center">
                    <v-col cols="6" v-if="lessons[0].id">
                        <v-btn color="primary" elevation="0" @click="add()">추가</v-btn>
                    </v-col>
                    <v-col cols="6" v-if="lessons[0].id == 0">
                        <v-btn color="normal" elevation="0" @click="cancel()" class="mr-3">취소</v-btn>
                        <v-btn v-if="lessons[0].name.trim().length > 2" color="secondary" elevation="0" @click="insert()">등록</v-btn>
                    </v-col>
                </v-row>
            </v-col>

            <v-col sm="12" md="6" :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
                <v-card outlined v-if="lesson || edit">
                    <v-toolbar class="mb-3 elevation-0" color="background">
                        <v-toolbar-title>{{subtitle}}</v-toolbar-title>
                    </v-toolbar>
                    <v-row class="pt-3 pl-3 pr-3" v-for="(content, i) in contents" :key="i" align-top>
                        <v-col cols="1"><v-icon>{{content.icon}}</v-icon></v-col>
                        <v-col cols="3" class="font-weight-light">{{content.title}}</v-col>

                        <v-col cols="8" v-if="edit == null">{{content.text}}</v-col>

                        <v-col cols="8" v-if="edit && i == 0 && login.level == 5">
                            {{login.studio_name}}
                        </v-col>                        
                        <v-col cols="8" v-if="edit && i == 0 && login.level == 10" class="pt-1 pb-0">
                            <v-select class="pa-0" v-model="edit.studio" :items="studios" />
                        </v-col>

                        <v-col cols="8" v-if="edit && i == 1" class="pt-0 pb-0">
                            <v-text-field class="pt-1 pb-0 font-14" v-model="edit.name" id="name" />
                        </v-col>

                        <v-col cols="8" v-if="edit && i == 2" class="pt-0 pb-0">
                            <v-text-field class="pt-1 pb-0 font-14" v-model="edit.time" type="number" />
                        </v-col>

                        <v-col cols="5" v-if="edit && i == 3" class="pt-1 pb-0">
                            <v-select class="pa-0 mt--5 font-14" v-model="edit.coupon_type" :items="couponTypes" />
                        </v-col>
                        <v-col cols="3" v-if="edit && i == 3" class="pt-1 pb-0">
                            <v-select class="pa-0 mt--5 font-14" v-model="edit.count" :items="counts" />
                        </v-col>
                        
                        <v-col cols="8" v-if="edit && i == 4" class="pt-0 pb-0">
                            <v-text-field class="pt-1 pb-0 font-14" v-model="edit.content" />
                        </v-col>

                        <v-col cols="8" v-if="edit && i == 5 && edit.cdate">
                            {{edit.cdate.slice(0, 19).replace('T', ' ')}}
                        </v-col>
                        <v-col cols="8" v-if="edit && i == 6 && edit.mdate">
                            {{edit.mdate.slice(0, 19).replace('T', ' ')}}
                        </v-col>
                    </v-row>
                    <v-spacer class="pa-3"/>
                    <v-divider />
                    <v-row class="pa-3" align="center" justify="end">
                        <v-col class="text-left" v-if="edit == null && (login.studio == 0 || lesson.studio == login.studio)">
                            <v-btn color="accent" elevation="0" @click="remove()">삭제</v-btn>
                        </v-col>
                        <v-col class="text-right" v-if="edit == null && (login.studio == 0 || lesson.studio == login.studio)">
                            <v-btn color="primary" elevation="0" @click="modify()">수정</v-btn>
                        </v-col>
                        <v-col class="text-right" v-if="edit">
                            <v-btn color="normal" @click="cancel()" class="mr-3 elevation-0">취소</v-btn>
                            <v-btn v-if="edit && lesson == null" color="secondary" elevation="0" @click="insert()">등록</v-btn>
                            <v-btn v-if="edit && lesson" color="secondary" elevation="0" @click="update()">적용</v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import axios from 'axios'
import util from '../utils/util'

export default {
    data () {
        return {
            login: null,
            lesson: null,
            lessons: [],
            studios: [],
            couponTypes: [],
            counts: [
                { value: 1, text: '1매' },
                { value: 2, text: '2매' },
                { value: 3, text: '3매' },
                { value: 4, text: '4매' },
                { value: 5, text: '5매' },
                { value: 10, text: '10매' }
            ],
            edit: null,
            page: 1,
            pages: 0,
            offset: 0,
            subtitle: '수업 내용',
            contents: [
                { icon: 'mdi-map-marker', title: '스튜디오', text: '' },
                { icon: 'mdi-tag', title: '수업명', text: '' },
                { icon: 'mdi-clock-outline', title: '시간', text: ''},
                { icon: 'mdi-ticket', title: '쿠폰', text: '' },
                { icon: 'mdi-content-paste', title: '내용', text: '' },
                { icon: 'mdi-calendar-plus', title: '등록일', text: '' },
                { icon: 'mdi-calendar-refresh', title: '수정일', text: '' }
            ],
        }
    },
    methods: {
        move: function () {
            this.offset = (this.page - 1) * 10
            this.lesson = null
        },

        select: function (lesson) {
            if (this.edit) {
                this.edit = null
            }
            if (lesson.id > 0) {
                this.lesson = lesson
                this.setContent()
            }
        },

        setContent: function () {
            this.subtitle = '수업 내용'
            this.contents[0].text = util.getItem(this.studios, this.lesson.studio).text
            this.contents[1].text = this.lesson.name
            this.contents[2].text = this.lesson.time + '분'
            this.contents[3].text = util.getItem(this.couponTypes, this.lesson.coupon_type).text + ' (' + this.lesson.count + '매)'
            this.contents[4].text = this.lesson.content
            this.contents[5].text = new Date(this.lesson.cdate).toLocaleString()
            this.contents[6].text = this.lesson.mdate ? new Date(this.lesson.mdate).toLocaleString() : ''
        },

        add: function () {
            this.subtitle = '수업 추가'
            this.lesson = null
            this.edit = {
                studio: this.login.studio,
                name: '',
                time: 60,
                coupon_type: 2,
                count: 1
            }
            setTimeout(() => { document.getElementById('name').focus() }, 1000)
        },

        insert: function () {
            if (this.edit.name.trim().length < 3) {
                document.getElementById('name').focus()
                return
            }
            if (this.edit.time == 0 || this.edit.count == 0) {
                return
            }
            let params = new URLSearchParams()
            params.append('name', this.edit.name)
            params.append('time', this.edit.time)
            params.append('coupon', this.edit.coupon_type)
            params.append('count', this.edit.count)
            params.append('content', this.edit.content ? this.edit.content : '')
            axios.post('/api/lesson/insert/' + this.login.studio, params, util.headers)
            .then(response => {
                if (response.data.error) {
                    this.lessons.shift()
                    console.log(response.data.error)
                }
                else {
                    this.edit = null
                    this.lesson = response.data.lesson
                    this.lessons.unshift(this.lesson)
                    this.setContent()
                }
            })
        },

        remove: function () {
            if (!confirm(this.lesson.name + ' 수업을 정말로 삭제하시겠습니까?')) {
                return
            }
            let params = new URLSearchParams()
            params.append('id', this.lesson.id)
            axios.post('/api/lesson/delete', params, util.headers)
            .then(response => {
                if (response.data.error) {
                    console.log(response.data.error)
                }
                else {
                    let index = this.lessons.map(lesson => { return lesson.id }).indexOf(this.lesson.id)
                    if (index >= 0) {
                        this.lessons.splice(index, 1)
                        this.lesson = null
                    }
                }
            })
        },

        cancel: function () {
            if (this.lessons[0].id == 0) {
                this.lessons.shift()
            }
            if (this.edit) {
                this.edit = null
            }
        },

        modify: function () {
            this.subtitle = '수업 수정'
            this.edit = JSON.parse(JSON.stringify(this.lesson))
        },

        update: function () {
            if (this.edit.name.trim().length < 3) {
                document.getElementById('name').focus()
                return
            }
            if (this.edit.time == 0 || this.edit.count == 0) {
                return
            }
            let params = new URLSearchParams()
            params.append('id', this.edit.id)
            params.append('name', this.edit.name)
            params.append('time', this.edit.time)
            params.append('coupon', this.edit.coupon_type)
            params.append('count', this.edit.count)
            params.append('content', this.edit.content ? this.edit.content : '')
            params.append('studio', this.edit.studio)
            axios.post('/api/lesson/update', params, util.headers)
            .then(response => {
                if (response.data.error) {
                    console.log(response.data.error)
                }
                else {
                    this.edit = null
                    let lesson = response.data.lesson
                    this.lesson.name = lesson.name
                    this.lesson.time = lesson.time
                    this.lesson.coupon_type = lesson.coupon_type
                    this.lesson.count = lesson.count
                    this.lesson.content = lesson.content
                    this.lesson.mdate = lesson.mdate
                    this.lesson.studio = lesson.studio
                    this.setContent()
                }
            })
        }
    },
    created () {
        console.clear()
        let json = localStorage.getItem('login')
        if (json) {
            this.login = JSON.parse(json)
        }
        if (this.login) {
            this.$emit('login', this.login)
                    
            util.getCouponTypes((couponTypes, error) => {
                if (error) console.log(error)
                this.couponTypes = couponTypes
            })

            util.getStudios((studios, error) => {
                if (error) console.log(error)
                this.studios = studios

                let studio = this.login.level == 5 ? this.login.studio : -1;
                axios.get(`/api/lesson/list/${studio}`)
                .then(response => {
                    if (response.data.error)
                        console.log(response.data.error)
                    else {                    
                        this.lessons = response.data.list
                        this.pages = Math.ceil(this.lessons.length / 10)
                        this.page = 1
                        this.move()
                    }
                })
            })
        }
        else {
            this.$router.push('/login')
        }
    }
}
</script>
<style scoped>
.ml--20 {
    margin-left: -20px;
}
.font-14 {
  font-size: 14px;
}
</style>